module.exports = __webpack_public_path__ + "static/img/trophy.6251a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contest/trophy.png
// module id = 5ZgT
// module chunks = 1